module.exports={
    "index": {
        "login": "Classificações de membros",
        "regist": "Presente para novos usuários",
        "user": "novo time",
        "jiang": "membro",
        "set": "Observação",
        "lingqyu": "Nenhum comentário inserido , por favor defina",
        "liji": "não foi inserido , configure-o",
        "list": {
            "0": "Tempo de depósito",
            "1": "Informações do cartão de débito",
            "2": "Nota : Carteira Bitcoin e recarga de carteira USDT. 10% de cortesia do valor principal da recarga + taxa de manuseio de US$ 20",
            "3": "Me desculpe, não entendi , por favor continue comprando",
            "4": "Dólar",
            "5": "O volume de pedidos no primeiro dia atingiu 20 e nenhum pedido adicional pode ser feito.",
            "6": "Envie agora"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "conta bancária",
                "1": "Cancelar o pedido"
            },
            "tianjia": {
                "0": "endereço",
                "1": "Nenhum endereço digitado , por favor defina-o"
            },
            "tiqu": {
                "0": "Por favor, insira",
                "1": "O saldo da conta é inferior a 200, recarregue antes de fazer um pedido"
            }
        },
        "guanyu": {
            "title1": "Verifique o saldo da conta",
            "text1": "Saldo de conta disponível insuficiente",
            "title2": "O pedido foi processado , atualize a página",
            "text2": "Erro de parâmetro , confirme o número do pedido"
        },
        "title_content": {
            "0": "O número do pedido não existe",
            "1": "Falha ao capturar o pedido . Não há estoque suficiente na faixa de preço desta categoria.",
            "2": "Falha ao capturar pedido . Tente novamente mais tarde!"
        },
        "content": {
            "0": "Pegue o pedido com sucesso",
            "1": "do pedido é insuficiente, peça novamente.",
            "2": "pegue isso"
        },
        "dugengduo": "Saldo de nível de associação insuficiente",
        "darkgrey": {
            "1": {
                "title": "A captura de pedidos foi encerrada",
                "text": "Verificar em tempo"
            },
            "2": {
                "title": "pegue um envelope vermelho",
                "text": "Vá para recarregar"
            },
            "3": {
                "title": "Olhe novamente",
                "text": "O saldo da conta precisa ser superior a 200 para desbloquear"
            },
            "4": {
                "title": "Próxima Etapa",
                "text": "Código de verificação"
            },
            "5": {
                "title": "insira o código de verificação",
                "text": "Falha na verificação do código de verificação gráfica . Digite novamente"
            },
            "6": {
                "title": "Solicitação bem-sucedida",
                "text": "O formato do número do celular está incorreto"
            }
        },
        "into": {
            "yibiaoban": "conta não existe",
            "nihao": "Usuário não existe",
            "yue": "Usuário desativado",
            "shebeigong": "Esta conta já está logada em outro lugar",
            "riqi": "A senha foi digitada incorretamente muitas vezes seguidas.",
            "gaishu": "Tente novamente em alguns minutos",
            "kaicaizong": "senha incorreta",
            "xiaoshili": "faça login com sucesso",
            "rili": "O código de verificação não existe",
            "zhouli": "Erro no código de verificação",
            "yeli": "Código de verificação inválido",
            "tuilian": "O código de convite não existe",
            "hezuo": "O usuário recomendado foi desativado",
            "fukuanxin": "Pedido ruim",
            "tianjiadi": "Por favor faça login primeiro",
            "gengxin": "Essa conta foi desativada",
            "yibiaoti": "A função de negociação desta conta foi congelada",
            "yaoqing": "Esta conta tem pedidos inacabados e não pode continuar recebendo pedidos.",
            "yaoqingren": "O saldo é menor que",
            "shijian": "Não é possível continuar negociando",
            "choujiangci": "Número insuficiente de transações para o nível de associação",
            "choujianggai": "tesouro de interesse",
            "tuijianren": "Retirada antecipada antes do vencimento , sem lucro, taxa de manuseio é",
            "xiejie": "O valor mínimo de investimento para este produto",
            "jiriqi": "O valor máximo de investimento para este produto",
            "dianjifu": "Anomalia de dados",
            "tishi": {
                "1": "Saldo disponível insuficiente",
                "2": "Operação bem-sucedida",
                "3": "A operação falhou ! Verifique o saldo da sua conta!"
            },
            "chongzhijin": "Iniciando investimento",
            "chongzhigai": "operar",
            "nindeyu": "Transferência de saldo de juros",
            "mianchong": "Repetir operação",
            "mianchongci": "Transferindo saldo de juros",
            "chongzhili": {
                "title": "Erro de parâmetro",
                "jine": "proibido de",
                "shijian": "Execute a operação atual fora do período de tempo",
                "zhauntai": "A recarga não pode ser inferior a"
            },
            "yijiangli": "A recarga não pode ser maior que",
            "yiqizhuan": "Erro no formato da imagem",
            "jianglili": "Falha no envio , tente novamente mais tarde",
            "shezhi": "Pagamento WeChat",
            "mimashe": "Pague com Ali-Pay",
            "dangqianmishu": "Retirada de dinheiro WeChat",
            "xinmi": "Retirada de dinheiro alipay",
            "shuxinmi": "Nenhuma informação de cartão bancário foi adicionada ainda",
            "quemi": "Nenhuma senha de transação definida",
            "shuquemi": "O limite de retirada do nível de associação é",
            "dainyou": "A retirada do nível atual precisa ser concluída",
            "dianyoudi": "pedidos",
            "shudainyou": "Saldo insuficiente",
            "fukuanshe": "O número de retiradas para nível de membro hoje é insuficiente.",
            "bitedi": "O nome do titular da conta é obrigatório",
            "shugukuan": "O comprimento máximo do nome do titular da conta é de 30 caracteres.",
            "jisheng": "O nome do banco é obrigatório",
            "qiangou": "O número do cartão bancário é obrigatório",
            "xiacixiaoshi": "O número do celular é obrigatório",
            "yingjian": "O número do cartão bancário já existe",
            "zonggong": "Operação falhou",
            "maidian": "A página não existe",
            "yingjiancheng": "Obtenha descontos",
            "zhuanzhang": "Usuário não logado",
            "dianfeizong": "Por favor, não reenvie",
            "zhuanzhangti": "obter sucesso",
            "zhaunzhangfeiyong": "falhar",
            "zuidifei": "sucesso",
            "tikuanjin": "Este nome e cartão bancário foram vinculados a outra conta",
            "zuidixian": "Não foi possível excluir o endereço de entrega padrão",
            "bijieshou": "Senha de login incorreta",
            "quezhi": "Conectado hoje",
            "querenti": "Faça login com sucesso e receba um envelope vermelho",
            "yiwen": "Faça login com sucesso",
            "tili": "Todos os seus pedidos de retirada",
            "yaohaoyou": "Verificação aprovada",
            "yaohuoci": "Por favor faça login para pegar um pedido",
            "yihanwei": "Falha ao capturar pedido , tente novamente mais tarde",
            "gongxihuo": "Falha na captura de pedidos , estoque de produtos insuficiente"
        },
        "taocan": {
            "title": "O número do celular foi registrado",
            "text": "Apenas uma mensagem de texto pode ser enviada em 1 minuto",
            "kuanggong": "Enviado com sucesso",
            "liliang": "Falha ao enviar",
            "jiage": "SMS enviado com êxito",
            "yingli": "Parâmetros incompletos"
        },
        "baoming": {
            "title": "O espaço do servidor não é compatível . Confirme se ele suporta curl ou fsocket. Entre em contato com seu provedor de espaço para resolver o problema ou alterar o espaço.",
            "text": "A conta expirou"
        }
    },
    "login": {
        "yongdeng": "Restrições de endereço IP",
        "quedeng": "O conteúdo contém palavras sensíveis",
        "yonghu": "Anormalidade nos parâmetros do produto",
        "mima": "O saldo disponível é insuficiente , recarregue primeiro",
        "xieyi": "Quantidade de hoje",
        "tiaokaun": "Número de usuários hoje",
        "tongyi": "Número de pessoas online hoje",
        "wangmi": "Ano",
        "zhaomi": "lua",
        "zhaomiti": "Entrar",
        "feihuiyuan": "contínuo",
        "lizhi": "Assinei hoje e recebi 1 envelope vermelho",
        "chaunghu": "dia",
        "yonghumming": "um",
        "mimafu": "dois",
        "zhanghaoyou": "Quatro",
        "jinggao": "cinco"
    },
    "botton": {
        "lianjie": {
            "0": "seis",
            "1": "Assinado",
            "2": "Já fez login hoje",
            "3": "transferir"
        },
        "zhichi": {
            "0": "transferência em",
            "1": "Shopping center"
        }
    },
    "content": {
        "zhichu": "um",
        "jiage": "Segunda categoria",
        "yinliang": "Sem permissão",
        "jiaoyizhe": "Mensagem de configuração",
        "btbjiage": "R",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3.000"
        }
    },
    "buchong": {
        "caidan": "5.000",
        "dengchu": "10.000",
        "shangdian": "30.000",
        "dan": "Uma conta pode ser obtida em 1 dia",
        "choujiang": "comissão de geração",
        "jiangli": "Nível 1",
        "chongzhi": "Três gerações de comissões",
        "zhuanzhang": "Nível três",
        "yongjin": "Carregar captura de tela de pagamento",
        "lijikaishi": "Suba para atualizar",
        "mianfei": "O próximo nível de canal exclusivo pode obter comissões mais altas",
        "kaishi": "Puxe para baixo para reorganizar",
        "lianjie": "Desconto de comissão subordinada",
        "zhoumo": "Não pode estar vazio",
        "shizhi": "Atendimento ao cliente dedicado",
        "jiaoyi": "As senhas inseridas duas vezes são inconsistentes",
        "zhichi": "As senhas dos fundos inseridas duas vezes são inconsistentes",
        "fuzhi": "informações pessoais",
        "dangqian": "Para evitar a supervisão da plataforma, como a correspondência de ordens",
        "wanshan": "Por favor, confirme a senha da transação",
        "buyizhi": "Mensagem do comprador",
        "ziyou": "aprender",
        "mai": "Comissão de segunda geração",
        "yaoqing": "Nível 2",
        "yihan": "Código QR",
        "gongxi": "Gerenciamento de senha de transação",
        "huifu": "Detalhes da transação"
    },
    "tanchuang": {
        "one": "Número de pedidos feitos hoje",
        "two": "Já peguei comissão hoje",
        "title1": "Resultados de hoje",
        "title2": "Os ganhos de hoje"
    },
    "weishangxian": {
        "weishangxian": "Após a conclusão da operação acima, entre em contato com o atendimento ao cliente para atualizar a pontuação.",
        "yueshouru": "preço",
        "meiyuan": "Mais tarefas",
        "qianggouzhong": "salão missionário",
        "chongzhidizhi": "Desconto de tarefa",
        "jine": "cupom",
        "bufu": "A adesão é válida para sempre",
        "zhengque": "nível de associação",
        "xuanxiang": "Detalhes do membro",
        "chongzhi": "Registros de depósito e retirada de Yu'e Bao",
        "xiaoshi": "Yu'e Bao patrimônio líquido",
        "yongjiu": "Transferência de Yu'e Bao",
        "yongjin": "Transferência de Yu'e Bao",
        "renshu": "Yu'E Bao",
        "hezuo": "pagamento de saldo",
        "fenxiang": "Transferência de saldo",
        "chenggong": "equilíbrio",
        "tuijianID": "Olá , para proteger seus direitos e interesses, vincule o número correto do cartão e as informações da agência dos quatro principais bancos (Banco da China, Construção, Indústria e Comércio, Agricultura se você preencher as informações erradas e a conta não puder). ser recebido, esta plataforma não terá qualquer responsabilidade! Esta plataforma não suporta saques em dinheiro de outros bancos que não os quatro principais bancos.",
        "neirong": "Comissão mais",
        "tuijian": "taxa de comissão"
    },
    "into_one": {
        "yibiaoban": "comissão",
        "nihao": "Salve o código QR no código de digitalização local",
        "yue": "Salvo com sucesso",
        "shebeigong": "Salve capturas de tela e escaneie o código QR para pagar",
        "riqi": "Anúncio de informação",
        "gaishu": "Modificar nome",
        "kaicaizong": "alterar a senha",
        "xiaoshili": "Modificado com sucesso",
        "rili": "Yuan",
        "zhouli": "Recarregando",
        "yeli": "Recarregando , atualize o saldo mais tarde",
        "tuilian": "Recarregue e atualize",
        "hezuo": "Status de recarga",
        "fukuanxin": "Atualize para desbloquear",
        "tianjiadi": "Recarregue para desbloquear",
        "gengxin": "Pedido de recarga com pagamento pendente",
        "yibiaoti": "Registro de recarga",
        "yaoqing": "Instruções de recarga",
        "yaoqingren": "Entre em contato com o atendimento ao cliente para recarga",
        "shijian": "Valor de recarga",
        "choujiangci": "completar",
        "choujianggai": "Recarregar .",
        "tuijianren": "registro gratuito",
        "xiejie": "Estamos trabalhando muito para conseguir pedidos e os resultados serão divulgados abaixo.",
        "jiriqi": "todos os produtos",
        "dianjifu": "Retirar tudo",
        "tishi": {
            "1": "todos",
            "2": "Congelando",
            "3": "Se o envio não for confirmado em minutos, o sistema congelará o valor do pedido."
        },
        "chongzhijin": "apontar",
        "chongzhigai": "excluir",
        "nindeyu": "Hora de chegada : 5 minutos",
        "mianchong": "ativos disponíveis restantes",
        "mianchongci": "carregando",
        "chongzhili": {
            "title": "atualização bem-sucedida",
            "jine": "Ir para carregar",
            "shijian": "Vá pegar um pedido",
            "zhauntai": "Vá para adicionar"
        },
        "yijiangli": "Envie o código de verificação",
        "yiqizhuan": "Cancelar",
        "jianglili": "Saldo disponível",
        "shezhi": "Saldo disponível",
        "mimashe": "tratados",
        "dangqianmishu": "colaborar",
        "xinmi": "nome",
        "shuxinmi": "Insira o estado de tempo limite após",
        "quemi": "mercadoria",
        "shuquemi": "Página inicial do shopping",
        "dainyou": "Voltar a página inicial",
        "dianyoudi": "Tamanho da equipe",
        "shudainyou": "Equilíbrio da equipe",
        "fukuanshe": "Status de comissão da equipe",
        "bitedi": "Comissão total da equipe",
        "shugukuan": "Recarga total da equipe",
        "jisheng": "Retirada total da equipe",
        "qiangou": "Comissão de pedido de equipe",
        "xiacixiaoshi": "Relatórios de equipe",
        "yingjian": "Fluxo da equipe",
        "zonggong": "Gerenciamento de equipe",
        "maidian": "equipe",
        "yingjiancheng": "Abra no navegador",
        "zhuanzhang": "Pagamento online",
        "dianfeizong": "área",
        "zhuanzhangti": "Copiado com sucesso",
        "zhaunzhangfeiyong": "Link de cópia",
        "zuidifei": "clone",
        "tikuanjin": "céu",
        "zuidixian": "Configurações de avatar",
        "bijieshou": "avatar",
        "quezhi": "Se você encontrar problemas e precisar de assistência, entre em contato com o atendimento ao cliente on-line",
        "querenti": "Nome",
        "yiwen": "depositar uma quantia",
        "tili": "O valor do depósito não atende aos requisitos do sistema",
        "yaohaoyou": "depósitos",
        "yaohuoci": "histórico de acesso",
        "yihanwei": "garantia oficial",
        "gongxihuo": "Fornecido oficialmente"
    },
    "into_two": {
        "yibiaoban": "Gestão financeira regular",
        "nihao": "Certamente",
        "yue": "Falha na auditoria",
        "shebeigong": "exame aprovado",
        "riqi": "Atendimento ao Cliente",
        "gaishu": "atendimento ao Cliente",
        "kaicaizong": "rede",
        "xiaoshili": "Gerenciamento de senha",
        "rili": "Prezado usuário, para garantir a segurança de seus fundos, vincule seu nome verdadeiro e defina uma senha de saque. Caso o nome não corresponda ao nome de abertura da conta, o saque não será possível",
        "zhouli": "O ponto decimal deve ser preenchido",
        "yeli": "horas, o sistema descongelará automaticamente após a expiração",
        "tuilian": "Deslize para a esquerda ou para a direita para ver mais",
        "hezuo": "Foi enviado",
        "fukuanxin": "concluído",
        "tianjiadi": "Revogado",
        "gengxin": "Por favor introduza o seu e-mail",
        "yibiaoti": "Já tem uma conta?",
        "yaoqing": "Já tem uma conta, baixe agora",
        "yaoqingren": "expirado",
        "shijian": "passado",
        "choujiangci": "Demitido",
        "choujianggai": "Comece seu caminho para a riqueza",
        "tuijianren": "Titular da conta",
        "xiejie": "Acordo de abertura de conta",
        "jiriqi": "Nome da conta",
        "dianjifu": "Endereço de abertura de conta",
        "tishi": {
            "1": "Banco de abertura de conta",
            "2": "Banco de depósito",
            "3": "Renda do dia"
        },
        "chongzhijin": "Pagamento Pendente",
        "chongzhigai": "Pendente",
        "nindeyu": "Revisão pendente",
        "mianchong": "Ser pago",
        "mianchongci": "Esperando recibo",
        "chongzhili": {
            "title": "Para ser desbloqueado",
            "jine": "Você pode pressionar e segurar diretamente para identificar o código QR no WeChat",
            "shijian": "esqueça a senha",
            "zhauntai": "Retirada rápida de dinheiro"
        },
        "yijiangli": "Recarga total",
        "yiqizhuan": "Retiradas totais",
        "jianglili": "Rendimento total",
        "shezhi": "Ativos totais",
        "mimashe": "seu balanço",
        "dangqianmishu": "Seu pedido será feito em",
        "xinmi": "Seu pedido foi congelado , aguarde pacientemente",
        "shuxinmi": "Seu pedido expirou e não pode ser processado",
        "quemi": "suas informações de identidade",
        "shuquemi": "Informações do seu cartão bancário",
        "dainyou": "Tem certeza de que deseja excluir este endereço?",
        "dianyoudi": "Você ainda não adicionou informações do cartão bancário",
        "shudainyou": "Eu concordei com o \"Contrato de Serviço\"",
        "fukuanshe": "Eu concluí o pagamento",
        "bitedi": "eu entendi e concordei",
        "shugukuan": "meu saldo",
        "jisheng": "meu time",
        "qiangou": "meus ativos totais",
        "xiacixiaoshi": "Meu número de celular",
        "yingjian": "Meu pedido",
        "zonggong": "Minha bolsa",
        "maidian": "Meu cartão de débito",
        "yingjiancheng": "meu",
        "zhuanzhang": "Captura de tela ou diretamente",
        "dianfeizong": "Banco",
        "zhuanzhangti": "Todos os produtos",
        "zhaunzhangfeiyong": "todos os tipos",
        "zuidifei": "O número do celular está errado",
        "tikuanjin": "Número de celular digitado incorretamente",
        "zuidixian": "número de telefone",
        "bijieshou": "Número de telefone",
        "quezhi": "celular",
        "querenti": "taxa de manuseio",
        "yiwen": "Pegando um pedido",
        "tili": "Hora de pegar o pedido",
        "yaohaoyou": "Número do pedido",
        "yaohuoci": "Registro de pedidos de captura",
        "yihanwei": "Registro",
        "gongxihuo": "Instruções para pegar pedidos"
    },
    "into_s1": {
        "yibiaoban": "pegue um pedido",
        "nihao": "Quantidade do pedido",
        "yue": "Desconto de comissão para receber pedidos",
        "shebeigong": "cartaz de promoção",
        "riqi": "Número recomendado de pessoas",
        "gaishu": "Produtos recomendados",
        "kaicaizong": "recomendar",
        "xiaoshili": "enviando",
        "rili": "Envio bem-sucedido , aguarde pacientemente pela revisão",
        "zhouli": "Envio bem-sucedido , será redirecionado em breve",
        "yeli": "Enviar pedido",
        "tuilian": "enviar",
        "hezuo": "Número de saques",
        "fukuanxin": "Status de retirada",
        "tianjiadi": "O pedido de retirada foi enviado",
        "gengxin": "Registro de retiradas",
        "yibiaoti": "Taxa de retirada",
        "yaoqing": "Quantidade retirada",
        "yaoqingren": "Limite de retirada",
        "shijian": "retirar",
        "choujiangci": "procurar",
        "choujianggai": "Forma de pagamento",
        "tuijianren": "Endereço da filial",
        "xiejie": "destinatário",
        "jiriqi": "Beneficiário",
        "dianjifu": "padrão de renda",
        "tishi": {
            "1": "Tipo de benefício",
            "2": "Registro de ganhos",
            "3": "Nome do consignado"
        },
        "chongzhijin": "Informações do endereço de entrega",
        "chongzhigai": "Modificação do endereço de entrega",
        "nindeyu": "Edição do endereço de entrega",
        "mianchong": "Endereço para envio",
        "mianchongci": "Recebendo informações de identidade",
        "chongzhili": {
            "title": "Novas pessoas",
            "jine": "Nova Senha",
            "shijian": "Novo número de celular",
            "zhauntai": "tempo"
        },
        "yijiangli": "Comissão de equipe de ontem",
        "yiqizhuan": "Lucro de ontem",
        "jianglili": "Sem dados",
        "shezhi": "Ainda não há registro",
        "mimashe": "Mais Informações",
        "dangqianmishu": "Mais",
        "xinmi": "O cartão do banco não está vinculado , vá vinculá-lo",
        "shuxinmi": "Nenhuma região inserida, por favor defina-a",
        "quemi": "O banco de abertura da conta não foi informado, configure-o",
        "shuquemi": "Endereço da filial não informado, defina-o",
        "dainyou": "Nenhum número de telefone inserido, configure-o",
        "dianyoudi": "Nenhum número de telefone inserido, configure-o",
        "shudainyou": "Nenhum nome real inserido, por favor defina-o",
        "fukuanshe": "Nenhum endereço detalhado inserido, defina-o",
        "bitedi": "Nenhum número de cartão bancário inserido, configure-o",
        "shugukuan": "não foi inserido , configure-o",
        "jisheng": "Esses dados são fornecidos por",
        "qiangou": "A taxa de manuseio será deduzida para esta retirada.",
        "xiacixiaoshi": "Carregando",
        "yingjian": "Pode receber pedidos todos os dias",
        "zonggong": "Não há código QR , por favor clique",
        "maidian": "sem dados",
        "yingjiancheng": "Não há mais conteúdo",
        "zhuanzhang": "Não há mais dados",
        "dianfeizong": "Sem registro",
        "zhuanzhangti": "Hora do registro",
        "zhaunzhangfeiyong": "registro",
        "zuidifei": "Nota: Devido à grande quantidade de informações de recarga, verifique cuidadosamente o número do cartão da conta antes de recarregar. Esta plataforma altera as contas de tempos em tempos. Se você tiver alguma dúvida, clique em atendimento ao cliente online.",
        "tikuanjin": "Centro de Atividades",
        "zuidixian": "Número de pessoas ativas",
        "bijieshou": "Novo endereço de entrega",
        "quezhi": "Dicas gentis",
        "querenti": "estado",
        "yiwen": "Recarga do usuário",
        "tili": "O nome de usuário não pode ficar vazio",
        "yaohaoyou": "Erro de entrada de nome de usuário , requer de 2 a 12 letras ou números",
        "yaohuoci": "O usuário recebe pedidos",
        "yihanwei": "Retirada do usuário",
        "gongxihuo": "número de telefone"
    },
    "into_f": {
        "yibiaoban": "Senha de login",
        "nihao": "Conecte-se",
        "yue": "Diretamente abaixo",
        "shebeigong": "Diretamente abaixo",
        "riqi": "nome real",
        "gaishu": "Confirmar modificação",
        "kaicaizong": "Confirmar vinculação do cartão",
        "xiaoshili": "Claro",
        "rili": "Confirmar recarga",
        "zhouli": "Você confirma o cancelamento ? O cancelamento resultará no congelamento do valor.",
        "yeli": "Confirme sua senha",
        "tuilian": "Confirma para sacar esse valor para o saldo? Não serão calculados juros sobre saques indevidos! e deduzir",
        "hezuo": "Confirmar para sair?",
        "fukuanxin": "Retorne à minha página em segundos",
        "tianjiadi": "Segundo",
        "gengxin": "Retire imediatamente",
        "yibiaoti": "comprar agora",
        "yaoqing": "atualize imediatamente",
        "yaoqingren": "Configurar agora",
        "shijian": "Aguardando confirmação do comprador",
        "choujiangci": "Aguardando confirmação do comprador",
        "choujianggai": "Aguardando resposta do sistema comercial",
        "tuijianren": "filtro",
        "xiejie": "Introdução",
        "jiriqi": "notificação do sistema",
        "dianjifu": "O sistema é baseado na tecnologia LBS e combina produtos automaticamente por meio da nuvem.",
        "tishi": {
            "1": "Conta do sistema",
            "2": "Renda acumulada",
            "3": "Recarga on-line"
        },
        "chongzhijin": "Recarga off-line",
        "chongzhigai": "Vincular número de celular",
        "nindeyu": "Vincular cartão bancário",
        "mianchong": "Estatisticas",
        "mianchongci": "Editar endereço de entrega",
        "chongzhili": {
            "title": "Editar cartão de débito",
            "jine": "editar",
            "shijian": "A rede não está estável , tente novamente em um local com melhor sinal",
            "zhauntai": "A rede está instável , tente novamente em um local com melhor sinal"
        },
        "yijiangli": "Número de contato",
        "yiqizhuan": "Vá pegar um pedido",
        "jianglili": "automático",
        "shezhi": "Cálculo automático",
        "mimashe": "Shopping autônomo",
        "dangqianmishu": "para",
        "xinmi": "Obtenha o código de verificação",
        "shuxinmi": "regra",
        "quemi": "Desbloquear",
        "shuquemi": "número do pedido",
        "dainyou": "O pedido foi congelado e o tempo de descongelamento é",
        "dianyoudi": "O pedido expirou",
        "shudainyou": "A quantidade total de pedidos",
        "fukuanshe": "Total de pedidos",
        "bitedi": "O pedido está sendo enviado",
        "shugukuan": "Pedidos enviados com sucesso",
        "jisheng": "detalhes do pedido",
        "qiangou": "Ordem",
        "xiacixiaoshi": "Lembrar senha",
        "yingjian": "Definir como endereço comum",
        "zonggong": "Definir como padrão",
        "maidian": "Definir avatar",
        "yingjiancheng": "Detalhes",
        "zhuanzhang": "Endereço",
        "dianfeizong": "Por favor carregue o comprovante de pagamento",
        "zhuanzhangti": "Por favor carregue o voucher de recarga",
        "zhaunzhangfeiyong": "Por favor, verifique as informações de pagamento com atenção",
        "zuidifei": "por favor pague",
        "tikuanjin": "Por favor mude seu nome",
        "zuidixian": "Certifique-se de manter o valor da transferência em casas decimais para evitar afetar o tempo de recarga.",
        "bijieshou": "Por favor, transfira e recarregue para a seguinte conta",
        "quezhi": "Consulte o atendimento ao cliente on-line após concluir a recarga",
        "querenti": "Por favor preencha o nome da recarga",
        "yiwen": "Por favor preencha o número do celular de recarga",
        "tili": "Por favor preencha o valor da recarga",
        "yaohaoyou": "Por favor preencha seu nome",
        "yaohuoci": "por favor preencha o número do celular",
        "yihanwei": "Por favor preencha o número de celular correto",
        "gongxihuo": "Por favor preencha o endereço detalhado"
    },
    "into_s": {
        "yibiaoban": "Por favor preencha o endereço de entrega detalhado",
        "nihao": "Lembre-se da sua senha . Se você esquecer sua senha, entre em contato com o atendimento ao cliente.",
        "yue": "Por favor, pergunte ao atendimento ao cliente online (a plataforma muda de conta de tempos em tempos)",
        "shebeigong": "Por favor insira a senha da transação",
        "riqi": "Insira o valor da recarga",
        "gaishu": "Por favor insira a senha original",
        "kaicaizong": "Por favor insira a senha",
        "xiaoshili": "Por favor insira o nome do titular da conta",
        "rili": "Insira o número do celular do titular da conta",
        "zhouli": "Por favor insira o endereço do banco de abertura da conta",
        "yeli": "Por favor insira o banco de abertura da conta",
        "tuilian": "Por favor, insira o banco onde a conta está aberta",
        "hezuo": "Por favor digite sua nova senha",
        "fukuanxin": "Por favor insira o número de telefone",
        "tianjiadi": "Por favor, insira o código de verificação do celular",
        "gengxin": "Por favor insira o código de referência",
        "yibiaoti": "Por favor insira o valor do saque",
        "yaoqing": "Por favor insira o nome do destinatário",
        "yaoqingren": "Por favor insira uma nova senha",
        "shijian": "Por favor insira o seu número de telemóvel ou endereço de e-mail",
        "choujiangci": "por favor insira o nome de usuário",
        "choujianggai": "Por favor digite sua senha de login",
        "tuijianren": "Por favor, insira o código de verificação por SMS",
        "xiejie": "Por favor insira sua conta /senha",
        "jiriqi": "Por favor insira a senha do fundo",
        "dianjifu": "Por favor insira o valor da transferência",
        "tishi": {
            "1": "Por favor insira o código do convite",
            "2": "Insira o número do cartão bancário",
            "3": "insira o código de verificação"
        },
        "chongzhijin": "Selecione o canal de pagamento",
        "chongzhigai": "Selecione o canal de pagamento",
        "nindeyu": "Por favor selecione o endereço de entrega",
        "mianchong": "Selecione o nível para o qual deseja atualizar",
        "mianchongci": "saldo da conta",
        "chongzhili": {
            "title": "Valor congelado da conta",
            "jine": "Detalhes da conta",
            "shijian": "Valor da conta",
            "zhauntai": "Produto da compra"
        },
        "yijiangli": "Compre sem inserir seu nome real, configure-o",
        "yiqizhuan": "Na compra de produtos financeiros , não serão calculados lucros para compras maliciosas e serão cobradas taxas de manuseio.",
        "jianglili": "Comprar",
        "shezhi": "Senha do fundo",
        "mimashe": "Redirecionando",
        "dangqianmishu": "Para transferir dinheiro, copie a mensagem e acesse o banco on-line ou Alipay para concluir a transferência e recarregar.",
        "xinmi": "Insira o valor da recarga",
        "shuxinmi": "Insira o nome",
        "quemi": "Insira o valor do depósito",
        "shuquemi": "insira o número do celular",
        "dainyou": "Digite a senha do fundo",
        "dianyoudi": "Retornando",
        "shudainyou": "retornar",
        "fukuanshe": "Nenhum endereço de colheita foi adicionado ainda",
        "bitedi": "Nenhum cartão bancário adicionado ainda",
        "shugukuan": "Entre na loja e dê uma olhada",
        "jisheng": "O host remoto está alocando",
        "qiangou": "sair",
        "xiacixiaoshi": "Escolha o método de recarga",
        "yingjian": "Escolha o método de retirada",
        "zonggong": "Selecione a quantidade",
        "maidian": "Escolha produtos financeiros",
        "yingjiancheng": "convide amigos",
        "zhuanzhang": "Cadastre-se para obter mais benefícios",
        "dianfeizong": "Código de Convite",
        "zhuanzhangti": "Link do convite : clique para copiar",
        "zhaunzhangfeiyong": "Por favor, verifique as informações de pagamento com atenção",
        "zuidifei": "Retirada de dinheiro do cartão financeiro",
        "tikuanjin": "Conta de cartão de débito",
        "zuidixian": "cartão do banco",
        "bijieshou": "nome do banco",
        "quezhi": "pergunta",
        "querenti": "Se precisar de ajuda, você pode entrar em contato com o atendimento ao cliente para recarregar manualmente.",
        "yiwen": "Precisa pagar de volta",
        "tili": "Receita estimada",
        "yaohaoyou": "Retorno esperado",
        "yaohuoci": "Número de pessoas que fazem o primeiro depósito",
        "yihanwei": "primeira página",
        "gongxihuo": "Recarregue agora"
    },
    "into_se": {
        "yibiaoban": "Código de verificação",
        "nihao": "padrão",
        "yue": "Faça manualmente uma captura de tela do APP e salve-a localmente para escanear o código QR.",
        "shebeigong": "Por favor, use o APP manualmente",
        "riqi": "Lar",
        "gaishu": "Senha de acesso",
        "kaicaizong": "Ainda não enviado",
        "xiaoshili": "Registro bem sucedido",
        "rili": "Pode ser atualizado",
        "zhouli": "Não foi possível atualizar",
        "yeli": "Não é possível atualizar se as condições de atualização não forem atendidas",
        "tuilian": "Você atingiu os critérios de atualização e concluiu a atualização",
        "hezuo": "notificação do sistema",
        "fukuanxin": "Saldo de usuário insuficiente",
        "tianjiadi": "Não há usuários convidados suficientes",
        "gengxin": "As condições de atualização não foram atendidas",
        "yibiaoti": "O saldo da conta necessário é maior que",
        "yaoqing": "convidar",
        "yaoqingren": "desbloquear",
        "shijian": "endereço da carteira",
        "choujiangci": "Verificação de carteira disponível para transferência",
        "choujianggai": "Comissão de equipe hoje",
        "tuijianren": "Baixar APLICATIVO",
        "xiejie": "Bônus de recarga",
        "jiriqi": "Por favor insira o endereço TRC20",
        "dianjifu": "Por favor insira o endereço ERC20",
        "tishi": {
            "1": "sobre nós",
            "2": "agente",
            "3": "regra"
        },
        "chongzhijin": "introduzir",
        "chongzhigai": "Qualificação",
        "nindeyu": "Surpresa ao abrir a caixa de presente",
        "mianchong": "Ganhe dinheiro imediatamente",
        "mianchongci": "Senha Antiga",
        "chongzhili": {
            "title": "Por favor insira a senha antiga",
            "jine": "Por favor insira a senha novamente",
            "shijian": "a senha foi atualizada",
            "zhauntai": "Falha ao alterar a senha"
        },
        "yijiangli": "Marque a caixa para concordar com o acordo",
        "yiqizhuan": "Você atingiu os critérios de upgrade e foi atualizado automaticamente",
        "jianglili": "Rebaixado devido a alteração de saldo",
        "shezhi": "notificação do sistema",
        "mimashe": "ordem de negociação",
        "dangqianmishu": "O pagamento foi forçado pelo sistema. Se você tiver alguma dúvida, entre em contato com o atendimento ao cliente.",
        "xinmi": "Ative a captura automática de pedidos",
        "shuxinmi": "Desative a captura automática de pedidos",
        "quemi": "Nome de usuário duplicado",
        "shuquemi": "Rebaixado devido a alteração de saldo",
        "dainyou": "Você atingiu os critérios de upgrade e foi atualizado automaticamente",
        "dianyoudi": "Telefone",
        "shudainyou": "sobre nós",
        "fukuanshe": "Veja Agora",
        "bitedi": "plataforma",
        "shugukuan": "anúncio",
        "jisheng": "Convide amigos para ganhar dinheiro",
        "chongxindenglu": "Por favor faça login novamente",
        "pingtaijianjie": "Introdução à plataforma",
        "pingtaijianjie1": "Regras de captura de pedidos",
        "pingtaijianjie2": "Cooperação entre agências",
        "pingtaijianjie3": "Qualificações da empresa"
    },
    "qing_sd": "Por favor, aguarde",
    "loading1": "proxy on-line",
    "loading2": "solicitar pedido",
    "loading3": "Pegando um pedido",
    "goods": {
        "0": "vidro verde",
        "1": "Produtos exclusivos para cuidados com a pele",
        "2": "Copo de plástico de qualidade alimentar",
        "3": "perfume clássico",
        "4": "grãos de café importados",
        "5": "Urso estilo Disney"
    },
    "tab_name": {
        "0": "primeira página",
        "1": "Registro de pedido",
        "2": "Fazer um pedido",
        "3": "atendimento ao Cliente",
        "4": "meu"
    },
    "pingjia": "Avalie",
    "login_t1": "One-stop shop for shopping around the world and earning rebates",
    "zhangh": "Por favor insira o número do celular",
    "email": "E-mail",
    "use_app": "Usar aplicativo",
    "index_t1": "30% de desconto extra + 10% de reembolso + frete grátis na sua primeira compra de aplicativo. Aplicam-se os Termos e Condições.",
    "qianbao": "carteira",
    "huoqu_yj": "Receba comissão",
    "zhangh_ye": "Saldo da conta",
    "zhangh_je": "saldo da conta",
    "huoq_yj": "Receba comissão",
    "dingd_s": "quantidade do pedido",
    "caoz_bz": "Passos",
    "caoz_t1": "1. Clique no botão Iniciar tarefa e siga as instruções para concluir a tarefa.",
    "caoz_t2": "2. Depois de concluir a tarefa, você pode liquidar a comissão no saldo",
    "kefu_t1": "Se você tiver alguma dúvida ou precisar de ajuda,",
    "kefu_t2": "Entre em contato com o atendimento ao cliente on-line para resolver isso para você",
    "kefu_t3": "Seu atendimento ao cliente dedicado",
    "changj_wtjd": "perguntas frequentes",
    "changj_wt": {
        "0": {
            "name": "Como recarregar e quais métodos de pagamento estão disponíveis ?",
            "value": "Este sistema está aberto a vários países e os métodos de pagamento internacionais que oferecemos incluem: USDT (ERC20). Ao mesmo tempo, também apoiamos as moedas nacionais de diferentes países."
        },
        "1": {
            "name": "Como posso investir e obter renda ?",
            "value": "Você pode participar de transações de mercadorias no sistema e obter uma receita de transação estável todos os dias. Todas as receitas podem ser retiradas para o seu cartão bancário."
        },
        "2": {
            "name": "Como se registrar como membro ?",
            "value": "Um sistema de convite é usado para registrar novos membros. A fim de garantir a renda dos membros registrados e evitar que o registro excessivo reduza a renda, os novos membros só podem se registrar a convite dos membros existentes."
        },
        "3": {
            "name": "Existe limite no valor da compra ?",
            "value": "Sim, para dar a mais membros a oportunidade de obter lucros, cada conta do sistema tem um limite mínimo de compra."
        }
    },
    "yonghu_m": "nome de usuário",
    "shoukuan_zh": "Contas a receber",
    "youxiang": "Correspondência",
    "zhanghao": "conta",
    "xiugai_mima": "alterar a senha",
    "xuanze_yy": "Escolha um idioma",
	queren:'confirme',
	bangka:'Vincule a conta de pagamento',
	xingy_d:'Parabéns, você pegou um pedido de sorte'
}